module.exports = __webpack_public_path__ + "static/modinfinity-indigo-9c6b015af2dd4a8be0d5fc1339521946.svg";